export const API_KEY_GET_TRANSLATION = "API_KEY_GET_TRANSLATION";
export const API_KEY_GET_TRANSLATION_LIST = "API_KEY_GET_TRANSLATION_LIST";
